const r = typeof window < "u" && window.document, s = "https://maps.googleapis.com/maps/api/js", i = (n) => {
  if (!r || typeof google < "u" && google.maps)
    return Promise.resolve();
  const o = document.querySelectorAll(
    `script[src*="${s}"]`
  );
  if (o && o.length)
    return new Promise((e) => {
      if (typeof google < "u") {
        e();
        return;
      }
      o[0].addEventListener("load", () => e());
    });
  const t = document.createElement("script");
  return t.src = n, document.body.appendChild(t), new Promise((e) => {
    t.addEventListener("load", () => e());
  });
};
export {
  r as isBrowser,
  i as loadGoogleMapScript
};
//# sourceMappingURL=loadGoogleMapScript.js.map
